import { render } from "./UserManagement.vue?vue&type=template&id=374c2ba4&ts=true"
import script from "./UserManagement.vue?vue&type=script&lang=ts"
export * from "./UserManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__